'use strict';

var CutFilter = function CutFilter() {
  return function (input, length) {
    if (!input || input.length <= length) {
      return input;
    } else {
      return input.substr(0, length) + '...';
    }
  };
};
CutFilter.$inject = [];
module.exports = CutFilter;